import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../context/AuthContext';

const CompleteProfile: React.FC = () => {
  const { user, refreshProfile } = useAuth();
  const [fullName, setFullName] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [diabetesType, setDiabetesType] = useState('Tipe 1');
  const [controlPlace, setControlPlace] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;

    setLoading(true);
    setError(null);

    try {
      const { error: profileError } = await supabase
        .from('profiles')
        .upsert([
          {
            id: user.id,
            full_name: fullName,
            birth_date: birthDate,
            diabetes_type: diabetesType,
            control_place: controlPlace,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          },
        ]);

      if (profileError) {
        throw profileError;
      }

      await refreshProfile();
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Gagal menyimpan profil.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen">
      <div className="screen-card">
        <div className="section-title">Lengkapi Profil</div>
        <div className="subtitle">
          Silakan lengkapi data diri Anda sebelum melanjutkan.
        </div>

        <form onSubmit={handleSave}>
          <div className="field-group">
            <div className="field">
              <label htmlFor="fullName">Nama Lengkap</label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                placeholder="Nama Lengkap"
              />
            </div>

            <div className="field">
              <label htmlFor="birthDate">Tanggal Lahir</label>
              <input
                id="birthDate"
                type="date"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                required
              />
            </div>

            <div className="field">
              <label htmlFor="diabetesType">Tipe Diabetes</label>
              <select
                id="diabetesType"
                value={diabetesType}
                onChange={(e) => setDiabetesType(e.target.value)}
              >
                <option value="Tipe 1">Tipe 1</option>
                <option value="Tipe 2">Tipe 2</option>
                <option value="Monogenik">Monogenik</option>
                <option value="Lainnya">Lainnya</option>
              </select>
            </div>

            <div className="field">
              <label htmlFor="controlPlace">Tempat Kontrol/Periksa</label>
              <input
                id="controlPlace"
                type="text"
                value={controlPlace}
                onChange={(e) => setControlPlace(e.target.value)}
                placeholder="Rumah Sakit / Klinik"
              />
            </div>
          </div>

          {error && (
            <div className="subtitle" style={{ color: '#b91c1c', marginTop: 16 }}>
              {error}
            </div>
          )}

          <div style={{ marginTop: 24 }}>
            <button
              type="submit"
              className="btn-primary w-full"
              disabled={loading}
            >
              {loading ? 'Menyimpan...' : 'Simpan Profil'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompleteProfile;
